(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      //Z1H001 - Skip if not search modal
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const productFormInputColor = document.querySelectorAll('.product-form__input [name="Color"]');
  let style = document.createElement('style')
  document.body.appendChild(style)
  productFormInputColor.forEach(color => {
    const colorImage = document.querySelector(`[data-alt='${color.value}'] img`);

    if(colorImage) {
      color.nextElementSibling.classList.add('has-variant-image');
      color.nextElementSibling.style.backgroundImage = `url(${colorImage.src})`;
    }
    if(color.checked) {
      color.parentElement.querySelector('legend').innerText = `Color: ${color.value}`
      style.innerHTML = `
        .product__media-list .slider__slide:not([data-alt='${color.value}']) {
          display: none;
        }
      `
    }
    
    color.addEventListener('change', () => {
    if(color.checked) {
      color.parentElement.querySelector('legend').innerText = `Color: ${color.value}`
      style.innerHTML = `
        .product__media-list .slider__slide:not([data-alt='${color.value}']) {
          display: none;
        }
      `
    }      
    })

     document.addEventListener('DOMContentLoaded', function() {


       
    // Find the sold out button
    let soldOutButton = document.querySelector('.product-form__submit');
       let productTitle = document.querySelector('.product__title .product__title h2')
            const productSelectedVariant = document.querySelector('.product-variant-id');
             let productVariantTitle = document.querySelector(`.varaint-info[data-id="${productSelectedVariant.value}"]`);
            const productFormTitle = document.querySelector('#ContactForm-title')
           productFormTitle.value = `${productTitle.innerText} - ${productVariantTitle.dataset.value}`;
    if (soldOutButton) {
      // Listen for click event on sold out button
      soldOutButton.addEventListener('click', function(event) {
        if(soldOutButton.classList.contains('disabled')) {
          setTimeout(() => {          
            event.preventDefault(); // Prevent default action
            productVariantTitle = document.querySelector(`.varaint-info[data-id="${productSelectedVariant.value}"]`);
            productFormTitle.value = `${productTitle.innerText} - ${productVariantTitle.dataset.value}`;
            // Show the overlay
            document.getElementById('overlay').style.display = 'block';
          }, 20)        
        }
      });

      // Find the cancel button
      let cancelButton = document.querySelector('.cancel-button');

      if (cancelButton) {
        // Listen for click event on cancel button
        cancelButton.addEventListener('click', function(event) {
          event.preventDefault(); // Prevent default action

          // Hide the overlay
          document.getElementById('overlay').style.display = 'none';
        });
      }

      // Function to handle intersection changes
      function handleIntersect(entries, observer) {
        
        const stickyBar = document.querySelector('.sticky-add-to-cart');
        // Z1H001 - Exit safely if sticky bar doesn't exist
        if (!stickyBar) return;
        
        entries.forEach(entry => {
          // If target element is intersecting (visible)
          if (entry.isIntersecting) {
            document.querySelector('.sticky-add-to-cart').classList.add('hidden');
          } else {
            document.querySelector('.sticky-add-to-cart').classList.remove('hidden');
          }
        });
      }
      
      // Create an intersection observer instance
      const observer = new IntersectionObserver(handleIntersect, {
        root: null, // Use the viewport as the root
        rootMargin: '0px', // No margin
        threshold: 0.5 // 50% threshold for intersection
      });
      
      // Target element to observe
      const target = document.querySelector('.product-form__buttons');
      console.log(target)
      // Start observing the target element
      observer.observe(target);

    }
  });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
      const videoPlay = document.querySelector('.video-section__poster');
      const videoMute = document.querySelector('button.mute-button')
      videoPlay.click();
    const slideShowText = document.querySelector('.slideshow__text');
      let video = videoPlay.nextElementSibling.nextElementSibling;
    videoPlay.classList.add('video-playing')
  videoPlay.addEventListener('click', function() {
          if (video.paused) {
              video.play();
              videoPlay.classList.add('video-playing')
          } else {
              video.pause();
              videoPlay.classList.remove('video-playing')
          }
      });



    videoMute.addEventListener('click', function() {
      console.log(videoMute)
         if (video.muted) {
                  video.muted = false;
                  videoMute.classList.add('active');
              } else {
                  video.muted = true;
                  videoMute.classList.remove('active');
              }
      });
    let section = document.querySelector('.section-video');
    // section.style.maxHeight = (section.offsetHeight - slideShowText.offsetHeight) + 'px'
  let scrollTop = window.scrollY;
                if (scrollTop > 20) {
                  section.classList.add('highlight');
              } else {
                  section.classList.remove('highlight');
              }
          window.addEventListener('scroll', function () {
              scrollTop = window.scrollY;

              if (scrollTop > 20) {
                  section.classList.add('highlight');
              } else {
                  section.classList.remove('highlight');
              }
          });
      slideShowText.parentElement.style.marginTop = -((slideShowText.offsetHeight * 2)) + 'px';
      slideShowText.parentElement.style.height = (slideShowText.offsetHeight * 3) + 'px';

  });

  } catch(e) { console.error(e); }
})();
})();
